import { Pipe, PipeTransform } from '@angular/core';
import {CrmLanguagesService} from "../pages/languages/crm-languages.service";
import {takeUntil} from "rxjs/operators";
import * as errorHandler from '@app-shared/utils/error-handler';
import {Subject} from "rxjs";
import md5 from 'md5';

@Pipe({
    name: 'translation'
})
export class TranslationPipe implements PipeTransform {
    translation: any;
    default: any = {};
    isUsingDefault = true;
    private _unsubscribeAll: Subject<any>;
    constructor(
        private _crmLanguagesService: CrmLanguagesService
    ) {
        this._unsubscribeAll = new Subject();
        this.default = require('../../assets/i18n/en.json');
        if (localStorage.getItem('crm_translation')) {
            const data = localStorage.getItem('crm_translation');
            const translations = JSON.parse(data);
            this.isUsingDefault = false;
            this.translation = this.copyDeeper(this.default, translations);
        } else {
            this.translation = this.default;
        }
    }

    transform(value: any, args?: any): any {
        if (this.isUsingDefault) {
            if (localStorage.getItem('crm_translation')) {
                const data = localStorage.getItem('crm_translation');
                const translations = JSON.parse(data);
                this.isUsingDefault = false;
                this.translation = this.copyDeeper(this.default, translations);
            }
        }

        if (typeof value !== 'string') {
            return 'N/A';
        }
        if (typeof this.translation !== "object") {
            return value;
        }
        if (!value.indexOf('.')) {
            return value;
        }
        const separator = value.indexOf('.');
        if (value.length <= separator+1) {
            return value;
        }
        // Not using split() in case the phrase has a period in it
        const category = value.substr(0, separator);
        const phrase = value.substr(separator+1);

        if (!this.translation.hasOwnProperty(category)
            && !this.default.hasOwnProperty(category)
        ) {
            // We don't really care if this API call fails occassionally
            this._crmLanguagesService.addPhrase(phrase, category)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(() => {}, (err) => {})
            ;
            return phrase;
        }
        // Load translated phrases from the file
        if (this.translation[category].hasOwnProperty(phrase)) {
            return this.translation[category][phrase];
        }
        // Load phrases from the file
        if (this.default[category].hasOwnProperty(phrase)) {
            return this.default[category][phrase];
        }

        // Load dynamic phrases
        const hash = md5(phrase);
        if (this.translation[category].hasOwnProperty(hash)) {
            return this.translation[category][hash];
        }
        if (this.default[category].hasOwnProperty(hash)) {
            return this.default[category][hash];
        }

        // Add phrase if it's not translated yet
        this._crmLanguagesService.addPhrase(phrase, category)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {}, (err) => {})
        ;

        return phrase;
    }

    protected copyDeeper(source, target) {
        const newObj = {...source};
        for (const i in target) {
            if (!target.hasOwnProperty(i)) {
                continue;
            }

            if (newObj.hasOwnProperty(i)) {
                newObj[i] = {...newObj[i], ...target[i]};
            } else {
                newObj[i] = {...target[i]};
            }
        }
        return newObj;
    }
};
